/*******************************************************************************
* Project: SMTM_EXM
* Summary:
*    Define FullDateFormatPipe Pipe
* History:
*    NguyenTV            2021/07/02    Create Date format pipe
******************************************************************************/

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
@Pipe({ name: 'fullDateFormatPipe' })
export class FullDateFormatPipe implements PipeTransform {
    transform(pStrDate: string, pFormat: string = 'yyyy/MM/dd'): string {
        try {
            if (pStrDate !== undefined && pStrDate != null && pStrDate !== '') {
                const yyyy = Number(pStrDate.substring(0, 4));
                const MM = Number(pStrDate.substring(4, 6)) - 1;
                const dd = Number(pStrDate.substring(6, 8));
                const date = new Date(yyyy, MM, dd);
                return new DatePipe('en-US').transform(date, pFormat);
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    }
}
